
import { Building, Mail, Phone, User } from "lucide-react";
import ContactSectionFormField from "./ContactSectionFormField";
import { useLanguage } from "@/contexts/LanguageContext";
import { FormData } from "./types";
import { FormErrors } from "./hooks/useContactForm";

interface BasicInfoFieldsProps {
  formData: FormData;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  errors?: FormErrors;
}

const BasicInfoFields = ({ formData, onChange, errors = {} }: BasicInfoFieldsProps) => {
  const { t } = useLanguage();
  
  return (
    <>
      <ContactSectionFormField
        id="companyName"
        name="companyName"
        label={t('contact_company')}
        value={formData.companyName}
        onChange={onChange}
        required
        maxLength={200}
        icon={<Building className="w-4 h-4 text-gray-400" />}
        error={errors.companyName}
      />
      
      <ContactSectionFormField
        id="contactName"
        name="contactName"
        label={t('contact_person')}
        value={formData.contactName}
        onChange={onChange}
        required
        maxLength={100}
        icon={<User className="w-4 h-4 text-gray-400" />}
        error={errors.contactName}
      />
      
      <ContactSectionFormField
        id="email"
        name="email"
        label={t('contact_email')}
        type="email"
        value={formData.email}
        onChange={onChange}
        required
        maxLength={255}
        icon={<Mail className="w-4 h-4 text-gray-400" />}
        error={errors.email}
      />
      
      <ContactSectionFormField
        id="phone"
        name="phone"
        label={t('contact_phone')}
        type="tel"
        value={formData.phone}
        onChange={onChange}
        maxLength={30}
        icon={<Phone className="w-4 h-4 text-gray-400" />}
        error={errors.phone}
      />
    </>
  );
};

export default BasicInfoFields;
